import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import Logo from "@/components/site/Logo";

const NAV_LINKS = [
  { href: "#services", label: "Services" },
  { href: "#about", label: "About" },
  { href: "#how-it-works", label: "How NDIS Works" },
  { href: "#testimonials", label: "Stories" },
  { href: "#faq", label: "FAQ" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 backdrop-blur-xl bg-[#F9F8F6]/85 border-b border-brand-sand/60"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 flex items-center justify-between h-20">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-3 group"
        >
          <span className="transition-transform group-hover:scale-105">
            <Logo size={56} />
          </span>
          <span className="hidden sm:flex flex-col leading-tight">
            <span className="font-heading font-semibold text-base text-brand-forest">Guiding Support Services</span>
            <span className="text-[11px] uppercase tracking-[0.18em] text-brand-muted">Registered NDIS Provider</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm font-medium text-brand-ink/80 hover:text-brand-forest transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a href="tel:0413918449" data-testid="nav-call" className="text-sm font-medium text-brand-muted hover:text-brand-forest">
            0413 918 449
          </a>
          <Button
            asChild
            data-testid="nav-cta-get-support"
            className="bg-brand-forest hover:bg-brand-forestDark text-brand-bone rounded-full px-6 py-5 text-sm font-semibold"
          >
            <a href="#contact">Get Support</a>
          </Button>
        </div>

        <button
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="lg:hidden grid place-items-center h-11 w-11 rounded-xl border border-brand-sand text-brand-forest"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden border-t border-brand-sand bg-brand-bone">
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-base font-medium text-brand-ink"
              >
                {l.label}
              </a>
            ))}
            <Button
              asChild
              data-testid="mobile-cta-get-support"
              className="bg-brand-forest hover:bg-brand-forestDark text-brand-bone rounded-full mt-2"
            >
              <a href="#contact" onClick={() => setOpen(false)}>Get Support</a>
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
